///<amd-module name="typeahead/core/message/EssErrorMessage" />

import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";

export class EssErrorMessage implements TypeaheadMessage {

    public static getTopic(): string {
        return "typeahead.ess_error";
    }

    constructor(private statusCode: string) {}

    public getTopic(): string {
        return EssErrorMessage.getTopic();
    }

    public getStatusCode(): string {
        return this.statusCode;
    }
}
